// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"ddd5a37a","289":"f2290289","368":"2999c262","453":"8de653e7","663":"2e7e503f","764":"56b0ff6c","795":"fcf01c3f","821":"9dab9f32"}[chunkId] + ".chunk.js";
};